/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Credentials } from '../models/credentials';
import { LoginByOtpRequestDto } from '../models/login-by-otp-request-dto';
import { RegisterDto } from '../models/register-dto';
import { RequestMagicLinkForLoginRequestDto } from '../models/request-magic-link-for-login-request-dto';
import { RequestOtpForLoginRequestDto } from '../models/request-otp-for-login-request-dto';
import { TokenDto } from '../models/token-dto';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation authControllerLoginOrRegisterByDescopeRefreshToken
   */
  static readonly AuthControllerLoginOrRegisterByDescopeRefreshTokenPath = '/auth/descope/login-or-register/{refreshToken}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginOrRegisterByDescopeRefreshToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginOrRegisterByDescopeRefreshToken$Response(params: {
    refreshToken: string;
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginOrRegisterByDescopeRefreshTokenPath, 'get');
    if (params) {
      rb.path('refreshToken', params.refreshToken, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginOrRegisterByDescopeRefreshToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginOrRegisterByDescopeRefreshToken(params: {
    refreshToken: string;
  }): Observable<TokenDto> {

    return this.loginOrRegisterByDescopeRefreshToken$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authControllerForgotPassword
   */
  static readonly AuthControllerForgotPasswordPath = '/auth/forgot-password/{username}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  forgotPassword$Response(params: {
    username: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerForgotPasswordPath, 'get');
    if (params) {
      rb.path('username', params.username, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `forgotPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  forgotPassword(params: {
    username: string;
  }): Observable<any> {

    return this.forgotPassword$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation authControllerGetUserByToken
   */
  static readonly AuthControllerGetUserByTokenPath = '/auth/get-user-by-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserByToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserByToken$Response(params?: {
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerGetUserByTokenPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserByToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserByToken(params?: {
  }): Observable<User> {

    return this.getUserByToken$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation authControllerLogin
   */
  static readonly AuthControllerLoginPath = '/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login$Response(params: {
    code?: string;

    /**
     * Credentials for login.
     */
    body: Credentials
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginPath, 'post');
    if (params) {
      rb.query('code', params.code, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  login(params: {
    code?: string;

    /**
     * Credentials for login.
     */
    body: Credentials
  }): Observable<TokenDto> {

    return this.login$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authControllerLoginByMagicLink
   */
  static readonly AuthControllerLoginByMagicLinkPath = '/auth/login-by-magic-link/{token}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginByMagicLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginByMagicLink$Response(params: {
    token: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginByMagicLinkPath, 'post');
    if (params) {
      rb.path('token', params.token, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginByMagicLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginByMagicLink(params: {
    token: string;
  }): Observable<any> {

    return this.loginByMagicLink$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation authControllerLoginByOtp
   */
  static readonly AuthControllerLoginByOtpPath = '/auth/login-by-otp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginByOTP()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByOTP$Response(params: {
    body: LoginByOtpRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerLoginByOtpPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loginByOTP$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  loginByOTP(params: {
    body: LoginByOtpRequestDto
  }): Observable<any> {

    return this.loginByOTP$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation authControllerRegister
   */
  static readonly AuthControllerRegisterPath = '/auth/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `register()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  register$Response(params?: {
    body?: RegisterDto
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerRegisterPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `register$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  register(params?: {
    body?: RegisterDto
  }): Observable<TokenDto> {

    return this.register$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authControllerRequestMagicLinkForLogin
   */
  static readonly AuthControllerRequestMagicLinkForLoginPath = '/auth/request-magic-link-for-login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestMagicLinkForLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestMagicLinkForLogin$Response(params: {

    /**
     * Magic link requested for login.
     */
    body: RequestMagicLinkForLoginRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerRequestMagicLinkForLoginPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `requestMagicLinkForLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestMagicLinkForLogin(params: {

    /**
     * Magic link requested for login.
     */
    body: RequestMagicLinkForLoginRequestDto
  }): Observable<any> {

    return this.requestMagicLinkForLogin$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation authControllerRequestOtpForLogin
   */
  static readonly AuthControllerRequestOtpForLoginPath = '/auth/request-otp-for-login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `requestOTPForLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestOTPForLogin$Response(params: {
    body: RequestOtpForLoginRequestDto
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, AuthControllerService.AuthControllerRequestOtpForLoginPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `requestOTPForLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  requestOTPForLogin(params: {
    body: RequestOtpForLoginRequestDto
  }): Observable<any> {

    return this.requestOTPForLogin$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
